import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { updateChatPostById } from '@/service/chatPostService';
import { Tooltip } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { disableAutoScroll } from '../handler/FootprintHandler';
import {
    generateTooltipReaction,
    getNewReactionByChatPost,
    isDisplayReactionBtn,
    validateReaction
} from '../handler/MessageHandler';
import { ReactionChatPost } from './ReactionChatPost';

const PADDING_REACT_TOOL_TIP = 10;

const ReactionTooltip = props => {
    const [isDisplay, setIsDisplay] = useState(false);
    const [tooltip, setTooltip] = useState('');

    const handleMouseIn = event => {
        setIsDisplay(true);
    };

    const handleMouseOut = event => {
        setIsDisplay(false);
    };

    useEffect(() => {
        if (
            !Utils.isEmptyObject(props.reaction) &&
            !Utils.isEmptyObject(props.userChatList) &&
            isDisplay
        ) {
            let tooltipValue = generateTooltipReaction(
                props.reaction,
                props.userChatList,
                props.userDetail
            );
            setTooltip(tooltipValue);
        }
    }, [props.reaction, props.userChatList, isDisplay]);

    useEffect(() => {
        if (isDisplay) {
            let elemTooltip = document.querySelector(`.tooltip-content`);
            let container = document.querySelector(
                `#divChatContentList-${props.panelId}-${props.selectThread?.id}`
            );
            if (elemTooltip && container) {
                let elemTooltips = elemTooltip.getBoundingClientRect();
                let containerChat = container.getBoundingClientRect();
                if (elemTooltips.right > containerChat.right) {
                    let widthNeedMove =
                        elemTooltips.right - containerChat.right + PADDING_REACT_TOOL_TIP;
                    elemTooltip.style.left = `calc(50% - ${widthNeedMove}px)`;
                }
                if (elemTooltips.left < containerChat.left) {
                    let widthNeedMove =
                        containerChat.left - elemTooltips.left + PADDING_REACT_TOOL_TIP;
                    elemTooltip.style.left = `calc(50% + ${widthNeedMove}px)`;
                }
            }
        }
    }, [isDisplay]);

    return (
        <>
            <div className="tooltip" onMouseOver={handleMouseIn} onMouseLeave={handleMouseOut}>
                {isDisplay ? (
                    <>
                        <div className="triangle"></div>
                        <div className="tooltip-content top">
                            <div className="reactionTooltip-wrap">
                                <div className="reactionTooltip-label">
                                    <em-emoji
                                        set="google"
                                        size="2em"
                                        id={props.reaction?.id}
                                    ></em-emoji>
                                </div>
                                <div
                                    className="reactionTooltip-content"
                                    dangerouslySetInnerHTML={{ __html: tooltip }}
                                ></div>
                            </div>
                        </div>
                    </>
                ) : (
                    <></>
                )}
                {props.children}
            </div>
        </>
    );
};

export const ListReactionByChatPost = ({ ...props }) => {
    const {
        userDetail,
        chatPost,
        chatPostAllList,
        setReactionErrorMsg,
        setIsOpenReactionErrorDialog,
        isAlignLeft,
        ticketDetailSelected,
        selectThread,
        isEnableChat,
        setChatPostUpdate,
        isDisableLink
    } = props;
    const [listReactionRender, setListReactionRender] = useState([]);

    // reaction popover
    const [reactionPopover, setReactionPopover] = useState(null);
    const [reactionPopoverId, setReactionPopoverId] = useState(null);
    const openReactionPopover = Boolean(reactionPopover);
    const reactionId = reactionPopover ? 'reaction-popover-id' : undefined;

    const args = {
        API: props?.API,
        panelId: props.panelId,
        selectThread: selectThread,
        userDetail: userDetail,
        chatPost: props.chatPost,
        chatPostAllList: chatPostAllList,
        reactionId,
        openReactionPopover,
        setReactionPopover,
        reactionPopoverId,
        reactionPopover,
        setReactionErrorMsg: props.setReactionErrorMsg,
        setIsOpenReactionErrorDialog: props.setIsOpenReactionErrorDialog,
        setChatPostUpdate: setChatPostUpdate
    };

    useEffect(() => {
        if (!Utils.isEmptyObject(chatPost)) {
            initListReaction();
        }
    }, [chatPost]);

    const initListReaction = () => {
        let listReactionResult = [];
        let reaction = chatPost.reaction ? Utils.convertJSONDataToObject(chatPost.reaction) : {};

        for (const [key, value] of Object.entries(reaction)) {
            let listUserReaction = value.userId;
            let reactionItem = {
                id: key,
                count: listUserReaction?.length,
                seq: value.seq,
                userId: listUserReaction,
                isMeReacted: listUserReaction?.includes(userDetail.id) ? true : false
            };
            listReactionResult.push(reactionItem);
        }

        listReactionResult = listReactionResult.sort((a, b) => {
            return a.seq?.localeCompare(b.seq);
        });

        let finalResult = [];
        let valueBlock = [];
        for (let i = 0; i < listReactionResult.length; i++) {
            let item = listReactionResult[i];

            if (i === 0) {
                valueBlock.push(item);
            } else {
                if (i % 7 === 0) {
                    if (!isAlignLeft) {
                        valueBlock = valueBlock.reverse();
                    }
                    finalResult.push(valueBlock);

                    valueBlock = [item];
                } else {
                    valueBlock.push(item);
                }
            }

            if (i === listReactionResult.length - 1) {
                valueBlock.push({
                    id: 'isBtnIconReaction'
                });

                if (!isAlignLeft) {
                    valueBlock = valueBlock.reverse();
                }
                finalResult.push(valueBlock);
            }
        }

        setListReactionRender(finalResult);
    };

    const onClickEmoji = async emojiSelected => {
        let isReactionAble = isDisplayReactionBtn(
            ticketDetailSelected,
            chatPost,
            selectThread,
            isEnableChat
        );

        if (!isReactionAble) return;

        disableAutoScroll(true);

        let reactionMsg = chatPost.reaction ? Utils.convertJSONDataToObject(chatPost.reaction) : {};
        let messageError = validateReaction(reactionMsg, emojiSelected.id, userDetail.id);

        if (messageError !== '') {
            setReactionErrorMsg(messageError);
            setIsOpenReactionErrorDialog(true);
            return;
        }

        reactionMsg = getNewReactionByChatPost(reactionMsg, emojiSelected.id, userDetail.id);

        let index = chatPostAllList.findIndex((element, i) => {
            return element.id === chatPost.id;
        });

        let msgDetail = { ...chatPostAllList[index] };
        if (Utils.isEmptyObject(msgDetail)) {
            return;
        }
        msgDetail.subcriptionType = Constant.SUBSCRIPTION_TYPE.UPDATE;
        msgDetail.reaction = JSON.stringify(reactionMsg);
        setChatPostUpdate(msgDetail);

        const updateData = {
            id: chatPost.id,
            reaction: JSON.stringify(reactionMsg),
            updatedAt: chatPost.updatedAt,
        };

        props.setIsLoading(true);
        updateChatPostById(props?.API, updateData).then(response => {
            props.setIsLoading(false);
        });
    };

    return (
        <>
            {listReactionRender.map((itemParent, index) => {
                return (
                    <span className="chatBox-label" key={index}>
                        <div className="reactionWrap">
                            {itemParent.map((item, i) => {
                                return item.id !== 'isBtnIconReaction' ? (
                                    <ReactionTooltip key={i} reaction={item} {...props}>
                                        <div
                                            className={isDisableLink ? `reaction-icon cursor-default` : "reaction-icon"}
                                            onClick={() =>{
                                                if (isDisableLink) return;
                                                onClickEmoji(item)
                                            }}
                                        >
                                            <div className="reaction-icon-label">
                                                <em-emoji
                                                    id={item.id}
                                                    set={'google'}
                                                    size={'1.3em'}
                                                ></em-emoji>
                                            </div>
                                            <span
                                                className={
                                                    item.isMeReacted
                                                        ? 'reaction-count me-reacted'
                                                        : 'reaction-count'
                                                }
                                            >
                                                {item.count}
                                            </span>
                                        </div>
                                    </ReactionTooltip>
                                ) : (
                                    <>
                                        {isDisplayReactionBtn(
                                            ticketDetailSelected,
                                            chatPost,
                                            selectThread,
                                            isEnableChat,
                                            isDisableLink
                                        ) && (
                                            <Tooltip
                                                placement="top"
                                                arrow
                                                title={I18n.get('COMBTN015')}
                                            >
                                                <div
                                                    aria-describedby={reactionId}
                                                    className="reaction-icon reaction-icon-btn"
                                                    onClick={event => {
                                                        disableAutoScroll(true);
                                                        setReactionPopover(event.currentTarget);
                                                        setReactionPopoverId(chatPost.id);
                                                    }}
                                                >
                                                    <img
                                                        src="/assets/image/icon-reaction.svg"
                                                        alt=""
                                                    />
                                                </div>
                                            </Tooltip>
                                        )}
                                        <ReactionChatPost chatPost={props.chatPost} {...args} />
                                    </>
                                );
                            })}
                        </div>
                    </span>
                );
            })}
        </>
    );
};
